import api from "@/services/api.service";
import readXlsxFile from "read-excel-file";
import { required } from "vuelidate/lib/validators";

export default {
  name: "add",
  components: { readXlsxFile },
  props: {},
  data() {
    return {
      caption: "Add Campaign",
      showField: true,
      formField: { name: "", type: "", operator_id: "", tags: [], file: "" },
      submitStatus: null,
      loader: false,
      existing_tags: [],
      permission_add: false,
      superAdmin: false,
      valImgMsg: '',
    };
  },
  computed: {},
  validations: {
    formField: {
      name: {
        required
      },
      type: {
        required
      },
      file: {
        required
      },
      tags: {
        required
      }
    }
  },
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_campaign") == true){
                this.getTags();    
                this.permission_add = permissions.includes("add_campaign");
            }else if(response.data[0].role == 'super_admin'){
              this.getTags();    
              this.superAdmin = true;
            }else if(permissions.includes("list_campaign") == true || permissions.includes("add_campaign") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'List Campaign'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }
  },
  mounted() {},
  methods: {
    makeToast(
      message = "",
      title = "Alert",
      variant = "warning",
      time = "3000"
    ) {  
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: time
      });
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
        );
      if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
          }.bind(this)
        );
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.loader = true;
        let response = await api.post("admin/campaign/add-campaign",this.formField);
        if (!response)
          this.makeToast(
            "Something went to wrong please try again",
            "Alert",
            "danger",
            6000
          );

        if (response.status == "success") {
          localStorage.removeItem("headers");
          this.makeToast(response.message, "Success", "success");
          this.$router.push({ name: "List Campaign" });
        } else {
          for (var error in response.errors)
            this.makeToast(response.errors[error], "Alert", "danger", 6000);
        }
        this.loader = false;
      }
    },
    onFileChanged(e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      if (file.type == "image/png" || file.type == "image/jpeg") {
        reader.onload = e => {
          this.formField.file = btoa(e.target.result);
          this.valImgMsg = '';        };
      } else {
        this.valImgMsg = 'File must be image .png or .jpeg';
        // this.makeToast("File must be image .png OR .jpeg", "Alert", "danger");
      }
      reader.readAsBinaryString(file);
    }
  }
};
